export default "__VITE_ASSET__DM5KFCge__"